import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.tsx';

if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

if (window.location.hash === '#dotted-nuke' || window.location.hash === '#desert-hydra') {
  window.history.replaceState(null, '', window.location.pathname + window.location.search);
}

window.scrollTo(0, 0);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
